import { defaultColors } from '../../../Common/Services/contexts/ServicesChartsDataContext';
import { Donut } from '../../../Common/Charts/Donut';
import { useGeneralProductionChartsDataContext } from './hooks/useGeneralProductionChartsDataContext';

export const ServicesBySex = () => {
    const { chartData } = useGeneralProductionChartsDataContext();

    return (
        <Donut
            title={'Atendimento por sexo'}
            subtitles={chartData?.servicesBySex?.map((item) => item.description)}
            chartData={chartData?.servicesBySex || []}
            colors={defaultColors.slice(0, chartData?.servicesBySex?.length) || []}
            height={400}
        />
    );
};
